import { TabsContent } from "@/components/ui/tabs";
import WorkOrderTab from "@/components/WorkOrderTab";

// Tab wrapper for the "Work Orders" section of the customer
// side-sheet. Embeds the full `<WorkOrderTab>` editor (its own
// massive component) scoped to the selected client + site.
// Extracted from Clients.jsx (Feb 2026, iter182).
export function ClientWorkOrdersTab({
  workOrderTabRef,
  selectedClient,
  clientSites,
  clientEquipment,
  getSiteNameById,
  selectedSiteId,
  pendingWorkOrderId,
  setPendingWorkOrderId,
  pendingCopyWO,
  setPendingCopyWO,
  pendingViewWO,
  setPendingViewWO,
  woReturnTo,
  setWoReturnTo,
  formData,
}) {
  return (
    <TabsContent value="workorders" className="mt-4">
      <WorkOrderTab
        ref={workOrderTabRef}
        clientId={selectedClient?.id}
        clientName={selectedClient?.name}
        clientSites={clientSites}
        clientEquipment={clientEquipment}
        getSiteNameById={getSiteNameById}
        selectedSiteId={selectedSiteId}
        openWorkOrderId={pendingWorkOrderId}
        onWorkOrderOpened={() => setPendingWorkOrderId(null)}
        copyFromWO={pendingCopyWO}
        onCopyHandled={() => setPendingCopyWO(null)}
        viewFromWO={pendingViewWO}
        onViewHandled={() => setPendingViewWO(null)}
        returnTo={woReturnTo}
        onReturnHandled={() => setWoReturnTo(null)}
        clientHideTax={!!selectedClient?.hide_tax}
        clientBillingContact={{
          name: selectedClient?.billing_contact_name || "",
          email: selectedClient?.billing_contact_email || "",
          phone: selectedClient?.billing_contact_phone || "",
        }}
        clientCustomerNumber={selectedClient?.customer_number || formData.customer_number || ""}
        clientCustomerType={selectedClient?.customer_type || ""}
      />
    </TabsContent>
  );
}
